var option_default = {
  "option": "umM3s",
  "user_choice": "GWV6B",
  "check": "ImVPm",
  "image": "_5rfkG",
  "input": "-SAIN",
  "title": "sKwvc",
  "centered": "_7Ax7E",
  "with_result": "ausTj",
  "list": "mQBSl",
  "with_image": "cpuUd",
  "progress": "ErHqs",
  "progress_value": "_9UjmG",
  "label": "XXdAH",
  "cta": "_0ey0n",
  "adornment_icon": "-UCj-",
  "remove": "IDqjX",
  "removeButton": "Gr3-9",
  "removeButtonIcon": "FaiUY",
  "overlay": "XL-ru",
  "shown": "JkZyV",
  "dark": "m61o9",
  "spinner": "_79CcV",
  "spin": "RrcnE"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
